export default __webpack_public_path__ + "static/media/utracker.36397be8.png";